import React, { Component } from "react";

import ViewVideo from "./components/ViewVideo";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
import styled from "styled-components";

import "./components/style.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import videos from "./videos";
import appvideos from "./appvideos";
import {
    withStyles,
    Typography,
    Tabs,
    Tab,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import SmartphoneIcon from "@material-ui/icons/Smartphone";
import ComputerIcon from "@material-ui/icons/Computer";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
    root: {
        width: "100%",
        flexGrow: 1,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
        color: "white",
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: "white",
    },
    paper: {
        padding: "2px",
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    media: {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: "cover",
    },
    cardParagraph: {
        whiteSpace: "nowrap",
        width: "200px",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    container: {
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gridGap: "2px",
    },
});

const TabsBar = styled(Tabs)`
    border: 1px solid black;
    width: fit-content;
    border-radius: 10px;
    background-color: white;
`;
const video_img = "https://img.youtube.com/vi/";

class Tutorials extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videos: videos,
            expanded: "User Management",
            selVideo: false,
            appvideos: appvideos,
            tabVal: "dashboard",
        };
    }
    handleChange = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };
    render() {
        const { classes } = this.props;
        const { expanded, videos, appvideos } = this.state;
        const { tabVal } = this.state;
        function youtube_parser(url) {
            var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var match = url.match(regExp);
            return match && match[7].length === 11 ? match[7] : false;
        }

        return (
            <>
                <StyledCard>
                    <StyledHeader>
                        <Typography variant="h5">
                            Tutorial Overview Page
                        </Typography>
                    </StyledHeader>

                    <StyledContent style={{ paddingTop: "0px" }}>
                        <TabsBar
                            indicatorColor="primary"
                            textColor="primary"
                            value={tabVal}
                            onChange={(event, value) => {
                                this.setState({ tabVal: value });
                            }}
                            style={{ borderWidth: 0, padding: "5px" }}
                            initialSelectedIndex={this.state.tabVal}
                        >
                            <Tab
                                value="dashboard"
                                label="Dashboard"
                                icon={<ComputerIcon />}
                            />
                            <Tab
                                value="application"
                                label="Application"
                                icon={<SmartphoneIcon />}
                            />
                            {/* <Tab value="2" label="Tips / Tricks"/> */}
                        </TabsBar>

                        <StyledViewContainer>
                            {tabVal === "dashboard" && (
                                <>
                                    <div className={classes.root}>
                                        {Object.keys(videos).map((e, i) => {
                                            return (
                                                <ExpansionPanel
                                                    expanded={expanded === e}
                                                    onChange={this.handleChange(
                                                        e
                                                    )}
                                                    style={{ marginTop: 24 }}
                                                >
                                                    <ExpansionPanelSummary
                                                        expandIcon={
                                                            <ExpandMoreIcon
                                                                style={{
                                                                    color:
                                                                        "white",
                                                                }}
                                                            />
                                                        }
                                                        aria-controls={
                                                            "panel" +
                                                            i +
                                                            "-content"
                                                        }
                                                        id={
                                                            "panel" +
                                                            i +
                                                            "-header"
                                                        }
                                                        style={{
                                                            background:
                                                                "#0188cc",
                                                            color: "white",
                                                        }}
                                                    >
                                                        <Typography
                                                            className={
                                                                classes.heading
                                                            }
                                                        >
                                                            {e}
                                                        </Typography>
                                                        <Typography
                                                            className={
                                                                classes.secondaryHeading
                                                            }
                                                        >
                                                            {videos[e].length
                                                                ? videos[e]
                                                                      .length
                                                                : "0"}{" "}
                                                            Tutorials
                                                        </Typography>
                                                    </ExpansionPanelSummary>
                                                    <ExpansionPanelDetails
                                                        style={{
                                                            background:
                                                                "#efefef",
                                                        }}
                                                    >
                                                        <div
                                                            className={
                                                                classes.root
                                                            }
                                                        >
                                                            <Grid
                                                                container
                                                                spacing={3}
                                                            >
                                                                {videos[e].map(
                                                                    (f) => {
                                                                        let video_id = youtube_parser(
                                                                            f.vid_url
                                                                        );
                                                                        let video_img_url =
                                                                            video_img +
                                                                            video_id +
                                                                            "/sddefault.jpg";

                                                                        return (
                                                                            <Grid
                                                                                item
                                                                                xs={
                                                                                    3
                                                                                }
                                                                                style={{
                                                                                    padding:
                                                                                        "5px",
                                                                                }}
                                                                            >
                                                                                <Card
                                                                                    className={
                                                                                        classes.card
                                                                                    }
                                                                                >
                                                                                    <CardMedia
                                                                                        component="img"
                                                                                        className={
                                                                                            classes.media
                                                                                        }
                                                                                        height="150"
                                                                                        image={
                                                                                            video_id
                                                                                                ? video_img_url
                                                                                                : require("./images/prowork.png")
                                                                                        }
                                                                                        title="Contemplative Reptile"
                                                                                        onClick={() => {
                                                                                            this.setState(
                                                                                                {
                                                                                                    selVideo: f,
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                    <CardContent
                                                                                        style={{
                                                                                            backgroundColor:
                                                                                                "#0188cc",
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            className={
                                                                                                classes.container
                                                                                            }
                                                                                        >
                                                                                            <div
                                                                                                style={{
                                                                                                    gridColumnEnd:
                                                                                                        "span 2",
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    src={require("./images/blue_favicon.png")}
                                                                                                    width="30"
                                                                                                    height="30"
                                                                                                    alt="fireSpot"
                                                                                                />
                                                                                            </div>
                                                                                            <div
                                                                                                style={{
                                                                                                    gridColumnEnd:
                                                                                                        "span 10",
                                                                                                }}
                                                                                            >
                                                                                                <Tooltip
                                                                                                    title={
                                                                                                        f.title
                                                                                                    }
                                                                                                    placement="right-end"
                                                                                                >
                                                                                                    <Typography
                                                                                                        className={
                                                                                                            classes.cardParagraph
                                                                                                        }
                                                                                                        component="p"
                                                                                                        style={{
                                                                                                            color:
                                                                                                                "white",
                                                                                                        }}
                                                                                                    >
                                                                                                        {
                                                                                                            f.title
                                                                                                        }
                                                                                                    </Typography>
                                                                                                </Tooltip>
                                                                                                <Typography
                                                                                                    component="p"
                                                                                                    style={{
                                                                                                        color:
                                                                                                            "white",
                                                                                                    }}
                                                                                                >
                                                                                                    <b>
                                                                                                        {" "}
                                                                                                        Prowork
                                                                                                    </b>
                                                                                                </Typography>
                                                                                            </div>
                                                                                        </div>
                                                                                    </CardContent>
                                                                                </Card>
                                                                            </Grid>
                                                                        );
                                                                    }
                                                                )}
                                                            </Grid>
                                                        </div>
                                                    </ExpansionPanelDetails>
                                                </ExpansionPanel>
                                            );
                                        })}

                                        <ViewVideo
                                            video={this.state.selVideo}
                                            setModalState={(e) => {
                                                this.setState({ selVideo: e });
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        </StyledViewContainer>
                        <StyledViewContainer>
                            {tabVal === "application" && (
                                <>
                                    <div style={{ paddingTop: "0px" }}>
                                        {Object.keys(appvideos).map((e, i) => {
                                            return (
                                                <ExpansionPanel
                                                    expanded={expanded === e}
                                                    onChange={this.handleChange(
                                                        e
                                                    )}
                                                    style={{ marginTop: 24 }}
                                                >
                                                    <ExpansionPanelSummary
                                                        expandIcon={
                                                            <ExpandMoreIcon
                                                                style={{
                                                                    color:
                                                                        "white",
                                                                }}
                                                            />
                                                        }
                                                        aria-controls={
                                                            "panel" +
                                                            i +
                                                            "-content"
                                                        }
                                                        id={
                                                            "panel" +
                                                            i +
                                                            "-header"
                                                        }
                                                        style={{
                                                            background:
                                                                "#0188cc",
                                                            color: "white",
                                                        }}
                                                    >
                                                        <Typography
                                                            className={
                                                                classes.heading
                                                            }
                                                        >
                                                            {e}
                                                        </Typography>
                                                        <Typography
                                                            className={
                                                                classes.secondaryHeading
                                                            }
                                                        >
                                                            {appvideos[e].length
                                                                ? appvideos[e]
                                                                      .length
                                                                : "0"}{" "}
                                                            Tutorials
                                                        </Typography>
                                                    </ExpansionPanelSummary>
                                                    <ExpansionPanelDetails
                                                        style={{
                                                            background:
                                                                "#efefef",
                                                        }}
                                                    >
                                                        <div
                                                            className={
                                                                classes.root
                                                            }
                                                        >
                                                            <Grid
                                                                container
                                                                spacing={3}
                                                            >
                                                                {appvideos[
                                                                    e
                                                                ].map((f) => {
                                                                    let video_id = youtube_parser(
                                                                        f.vid_url
                                                                    );
                                                                    let video_img_url =
                                                                        video_img +
                                                                        video_id +
                                                                        "/sddefault.jpg";
                                                                    return (
                                                                        <Grid
                                                                            item
                                                                            xs={
                                                                                3
                                                                            }
                                                                            style={{
                                                                                padding:
                                                                                    "5px",
                                                                            }}
                                                                        >
                                                                            <Card
                                                                                className={
                                                                                    classes.card
                                                                                }
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        "#0188cc",
                                                                                }}
                                                                            >
                                                                                <CardMedia
                                                                                    component="img"
                                                                                    className={
                                                                                        classes.media
                                                                                    }
                                                                                    height="140"
                                                                                    image={
                                                                                        video_id
                                                                                            ? video_img_url
                                                                                            : require("./images/prowork.png")
                                                                                    }
                                                                                    title="Contemplative Reptile"
                                                                                    onClick={() => {
                                                                                        this.setState(
                                                                                            {
                                                                                                selVideo: f,
                                                                                            }
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                <CardContent
                                                                                    style={{
                                                                                        backgroundColor:
                                                                                            "#0188cc",
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        className={
                                                                                            classes.container
                                                                                        }
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                gridColumnEnd:
                                                                                                    "span 2",
                                                                                            }}
                                                                                        >
                                                                                            <img
                                                                                                src={require("./images/blue_favicon.png")}
                                                                                                width="30"
                                                                                                height="30"
                                                                                                alt="fireSpot"
                                                                                            />
                                                                                        </div>
                                                                                        <div
                                                                                            style={{
                                                                                                gridColumnEnd:
                                                                                                    "span 10",
                                                                                            }}
                                                                                        >
                                                                                            <Tooltip
                                                                                                title={
                                                                                                    f.title
                                                                                                }
                                                                                                placement="right-end"
                                                                                            >
                                                                                                <Typography
                                                                                                    className={
                                                                                                        classes.cardParagraph
                                                                                                    }
                                                                                                    component="p"
                                                                                                    style={{
                                                                                                        color:
                                                                                                            "white",
                                                                                                    }}
                                                                                                >
                                                                                                    {
                                                                                                        f.title
                                                                                                    }
                                                                                                </Typography>
                                                                                            </Tooltip>
                                                                                            <Typography
                                                                                                component="p"
                                                                                                style={{
                                                                                                    color:
                                                                                                        "white",
                                                                                                }}
                                                                                            >
                                                                                                <b>
                                                                                                    {" "}
                                                                                                    Prowork
                                                                                                </b>
                                                                                            </Typography>
                                                                                        </div>
                                                                                    </div>
                                                                                </CardContent>
                                                                            </Card>
                                                                        </Grid>
                                                                    );
                                                                })}
                                                            </Grid>
                                                        </div>
                                                    </ExpansionPanelDetails>
                                                </ExpansionPanel>
                                            );
                                        })}

                                        <ViewVideo
                                            video={this.state.selVideo}
                                            setModalState={(e) => {
                                                this.setState({ selVideo: e });
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                        </StyledViewContainer>
                    </StyledContent>
                </StyledCard>
            </>
        );
    }
}

export default withStyles(styles)(Tutorials);
